/* eslint-disable */
import React, { Component } from 'react';
import { LoadingSpinnerContainer, LoadingSpinnerDot } from './styles';

class LoadingSpinner extends Component {
  render() {
    const { shouldAnimate, position, withContainer } = this.props;
    if (!shouldAnimate) {
      return null;
    }
    const spinnerMarkup = (
      <LoadingSpinnerContainer position={position}>
        <LoadingSpinnerDot id="dot_1" />
        <LoadingSpinnerDot id="dot_2" />
        <LoadingSpinnerDot id="dot_3" />
        <LoadingSpinnerDot id="dot_4" />
        <LoadingSpinnerDot id="dot_5" />
        <LoadingSpinnerDot id="dot_6" />
        <LoadingSpinnerDot id="dot_7" />
        <LoadingSpinnerDot id="dot_8" />
      </LoadingSpinnerContainer>
    );
    return withContainer ? <div style={withContainer}>{spinnerMarkup}</div> : spinnerMarkup;
  }
}

export default LoadingSpinner;

/* eslint-disable */



/** WEBPACK FOOTER **
 ** ./src/components/LoadingSpinner/index.js
 **/